<template lang="pug">
.v-gallery.gallery(ref="modal" data-scroll-lock-scrollable :class="{'open': open}" @transitionend="handleTransitionEnd")
	.gallery__overlay(@click="handleClose")
	.gallery__content
		transition(name="fade" mode="out-in")
		img.gallery__img(v-if="this.open" :src="data.image.src")
		button.gallery__close(type="button" @click="handleClose") {{ data.closeText }}
			v-svg-icon.gallery__close-icon(icon="cross")
</template>

<script>

import scrollLock from 'scroll-lock';

export default {

	emits: [
		'close'
	],

	props: {
		data: {
			type: Object,
			default: null
		}
	},

	data() {
		return {
			open: false
		}
	},

	watch: {
		open(state) {
			if (state) {
				scrollLock.disablePageScroll(this.$refs.gallery);
			} else {
				setTimeout(() => {
					scrollLock.enablePageScroll(this.$refs.gallery);
				}, 300);
			}
		}
	},

	mounted() {
		this.open = true;
	},

	methods: {
		handleClose() {
			this.open = false;
		},

		handleTransitionEnd() {
			!this.open ? this.$emit('close') : null;
		}
	},

	beforeUnmount() {
		setTimeout(() => {
			scrollLock.enablePageScroll(this.$refs.gallery);
		}, 300);
	}
}

</script>
